module.exports = __webpack_public_path__ + "static/media/vendor_pickup.c702442c.jpg";